/** 일자별 기록 노트(대시보드 위클리·데일리 노트 페이지) */

export type DailyRecordNoteRow = {
  id: string;
  user_id: string;
  note_date: string;
  body: string;
  category_id: string | null;
  created_at: string;
  updated_at: string;
};

export type DailyNoteCategorySystemKey = 'general' | 'daily' | 'sticky';

export type DailyNoteCategoryRow = {
  id: string;
  user_id: string;
  name: string;
  color: string;
  sort_order: number;
  created_at: string;
  updated_at: string;
  system_key: DailyNoteCategorySystemKey | null;
};

/** dateIso(YYYY-MM-DD) → body (같은 날 여러 건은 본문을 이어 붙임) */
export type DailyRecordNotesByDate = Record<string, string>;

/** 위클리 일자별 기록 편집용 초안 */
export type DailyWeekNoteDraft = {
  id: string;
  note_date: string;
  body: string;
  category_id: string | null;
  persisted: boolean;
};

export type DailyRecordNotesWeekPayload = {
  notes: DailyWeekNoteDraft[];
};

export const DEFAULT_DAILY_CATEGORY_NAME = '데일리';
export const LEGACY_GENERAL_DAILY_CATEGORY_NAME = '일반';
export const DEFAULT_DAILY_CATEGORY_COLOR = '#ffffff';
export const STICKY_SYSTEM_CATEGORY_NAME = '기본쪽지';
export const STICKY_SYSTEM_CATEGORY_COLOR = '#fff59d';
